import React from 'react';
import EvaluatorService from '../../../Services/EvaluatorService';
import TipaltiEvaluatorDataItem from '../../Evaluator/EvaluatorAdmin/TipaltiEvaluatorDataItem';
import ShowEntityData from '../../../Elements/ShowEntityData';

export default class TipaltiProfileTab extends React.Component {
  static defaultProps = {
    tipaltiId: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      tipaltiEvaluatorData: null,
    };
  }

  render() {
    if (this.state.tipaltiEvaluatorData?.ErrorMessage && this.state.tipaltiEvaluatorData?.ErrorMessage !== 'OK') {
      return (
        <div>
          <h4 className='text-center'>Tipalti has sent the following message:</h4>
          <h1 className='text-center'>{this.state.tipaltiEvaluatorData?.ErrorMessage}</h1>
        </div>
      );
    }
    return (
      <ShowEntityData
        itemId={this.props.tipaltiId}
        type={TipaltiEvaluatorDataItem}
        serviceGetByIdFunction={EvaluatorService.GetTipaltiEvaluatorData}
        itemChanged={(item) => this.setState({ tipaltiEvaluatorData: item })}
        useItemTypeTitle={true}
        showRefreshButton={false}
      />
    );
  }
}
